const deleteEvent = (apiDelete) => (id) => apiDelete(`/me/calendar/events/${id}`);

export default deleteEvent;
